<div class="flex-row">
  @for (element of elements(); track $index) {
    <div [id]="'chipsElement'+$index" [matTooltip]="element.tooltip"
         [attr.data-testid]="testIdPrefix() ? testIdPrefix() + '-' + element.value : null"
         [attr.data-cursor]="disabled() ? 'hover-disabled' : 'hover-enabled'"
         class="{{colorClass()}} chips relative {{element.value === value() ? 'chips-' + (element.selectedState ?? 'active') : 'chips-enabled' }} shrink-0"
         [style.height]="contentHeight() ? 'inherit' : '32px'"
         (click)="selectElement(element)"
         [ngClass]="{'first-chips': $first, 'last-chips': $last, 'middle-chips': !$first && !$last, 'z-1': element.value === value()}">
      @if (element.icon) {
        @if (IconService.isSvgIcon(element.icon)) {
          <mat-icon class="icon" [svgIcon]="element.icon"/>
        } @else {
          <mat-icon class="icon">{{ element.icon }}</mat-icon>
        }
      }
      @if (element.name) {
        {{ element.name }}
      }
    </div>

  }

</div>
